import { Link } from 'react-router-dom';
import type { ContentItem } from '@/types/content';

export default function NewsCard({ item }: { item: ContentItem }) {
  return (
    <article className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors">
      <Link to={`/detail/${item.id}`} className="flex flex-col sm:flex-row cursor-pointer">
        <div className="w-full sm:w-[220px] h-44 sm:h-auto shrink-0 overflow-hidden bg-background-200">
          <img
            src={item.cover}
            alt={`${item.title} 赛事资讯配图`}
            title={`${item.title} - 51每日大赛`}
            className="w-full h-full object-top object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="flex-1 p-4 md:p-5 flex flex-col">
          <div className="flex items-center gap-2 mb-2 flex-wrap">
            <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-900 whitespace-nowrap">
              {item.category}
            </span>
            <span className="text-xs text-foreground-500 whitespace-nowrap">{item.event}</span>
          </div>
          <h3 className="text-base md:text-lg font-bold text-foreground-950 leading-snug mb-2 group-hover:text-primary-700 transition-colors">
            {item.title}
          </h3>
          <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
            {item.summary}
          </p>
          <div className="mt-auto flex items-center gap-3 text-xs text-foreground-500 flex-wrap">
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-user-line"></i>
              {item.author}
            </span>
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-time-line"></i>
              {item.date}
            </span>
            <span className="px-2 py-0.5 rounded bg-background-100 text-foreground-600 whitespace-nowrap">
              {item.source}
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}